import { createFileRoute, redirect } from '@tanstack/react-router'
import { bootstrapQueryOptions } from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import { canManageOrganizationAsOwner } from '@/features/organizations/domain/organization-role'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { OrganizationAgentEditPage } from '@/pages/organization/agents/edit'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'
import { redirectToGtmEntry } from '@/shared/lib/gtm-route-guard'

export const Route = createFileRoute(
  '/$lang/organization/agents/$agentId/edit',
)({
  beforeLoad: async ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      redirectToGtmEntry(context, params)
    }
    requireAuthenticated(context, params)
    const bootstrap = await context.queryClient.ensureQueryData(
      bootstrapQueryOptions(),
    )
    if (!canManageOrganizationAsOwner(bootstrap.organization?.role)) {
      throw redirect({
        to: '/$lang/organization/agents',
        params: { lang: params.lang },
      })
    }
  },
  component: OrganizationAgentEditPage,
  staticData: { layout: 'main' },
})
